function initSaunderAnimation() {
  var canvas = document.getElementById('sequenceCanvas');
  var contentColumn = document.getElementById('contentColumn');

  if (!canvas || !contentColumn) {
    console.log('Scroll animation elements not found on this page');
    return;
  }

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(initSaunderAnimation, 100);
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var rafId = null;
  var isRendering = false;
  var lastProgress = -1;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ctx = canvas.getContext('2d', { alpha: false });
  var video = document.createElement('video');
  var isVideoLoaded = false;
  var videoDuration = 10;
  var currentTime = 0;
  var videoLoadAttempts = 0;
  var maxVideoLoadAttempts = 2;
  var videoLoadingComplete = false;
  var initialRenderDone = false;

  var animationData = {
    progress: 0
  };

  var videoURL = 'https://cdn.shopify.com/videos/c/o/v/a4111016ecc14babb24a0c6212f43f7a.mp4';

  var segmentData = {
    "start": {
      "title": "A new way to sweat",
      "subtitle": "This isn't your grandpa's sauna setup. Our sauna tents are made to go, but never compromise on a serious sweat.",
      "progress": 0,
      "hotspots": []
    },
    "p1": {
      "title": "Your anywhere hot spot",
      "subtitle": "Saunder sets up in minutes and packs down small enough to fit in your trunk, so you can bring it on any adventure.",
      "progress": 0.33,
      "hotspots": [
        {
          "x": 0.3,
          "y": 0.55,
          "title": "Anchor Points / Tie-Downs",
          "description": "Ground stakes and ties anchor your sauna experience."
        },
        {
          "x": 0.5,
          "y": 0.45,
          "title": "Lightweight Materials",
          "description": "Strong, lightweight fibreglass frame keeps things sturdy without weighing you down."
        }
      ]
    },
    "p2": {
      "title": "Made better",
      "subtitle": "Our unique three-layer fabric traps the heat and blocks out the elements.",
      "progress": 0.48,
      "hotspots": [
        { "x": 0.35, "y": 0.4, "title": "Sweatloft Fabric", "description": "Insulated 120gsm cotton fill keeps it crazy hot inside while durable, heat-resistant 450D Oxford fabric stays weather-ready." },
        { "x": 0.7, "y": 0.55, "title": "Cool-Touch Zipper Pulls and Storm Flaps", "description": "Custom silicone pulls stay cool to the touch while storm flaps keep rain and wind out." }
      ]
    },
    "p3": {
      "title": "Built for company",
      "subtitle": "Bring a friend...or three. Our tent is spacious enough for a crew, but you can always stretch out solo.",
      "progress": 0.64,
      "hotspots": [
        { "x": 0.6, "y": 0.5, "title": "Layout", "description": "High ceilings and a smart layout make entering safe and sweating comfortable." },
        { "x": 0.5, "y": 0.25, "title": "Height", "description": "Over 205 cm tall - plenty of room to stand, stretch, and relax." }
      ]
    },
    "p4": {
      "title": "Enjoy your view",
      "subtitle": "Sometimes you want to take in your surroundings. Our large insulated windows let you connect to nature or close it all off.",
      "progress": 0.76,
      "hotspots": [
        { "x": 0.6, "y": 0.4, "title": "Windows", "description": "Clear-view panels bring in light and frame the landscape around you." },
        { "x": 0.3, "y": 0.4, "title": "Insulated Covers", "description": "Removable velcro covers offer instant privacy and added heat retention." }
      ]
    },
    "end": {
      "title": "Ready, set, sauna",
      "subtitle": "No bookings. No strangers. Just a sweet, sweet sweat on your terms.",
      "progress": 1.0,
      "hotspots": []
    }
  };

  var showHotspots = false;

  function generateContentBlocks() {
    Object.entries(segmentData).forEach(function(entry, index) {
      var key = entry[0];
      var segment = entry[1];
      var contentBlock = document.createElement('div');
      contentBlock.className = 'content-block segment-' + index;

      var hotspotHTML = '';
      if (segment.hotspots && segment.hotspots.length > 0) {
        hotspotHTML = '<ol>' + segment.hotspots.map(function(hotspot) {
          return '<li><strong>' + hotspot.title + '</strong><br>' + hotspot.description + '</li>';
        }).join('') + '</ol>';
      }

      contentBlock.innerHTML = '<h1>' + segment.title + '</h1><h2>' + segment.subtitle + '</h2>' + hotspotHTML;
      contentColumn.appendChild(contentBlock);
    });
  }

  generateContentBlocks();

  function renderInitialFrame() {
    ctx.fillStyle = 'rgb(253, 253, 253)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (isVideoLoaded && video.readyState >= 2) {
      var videoAspect = video.videoWidth / video.videoHeight;
      var canvasAspect = canvas.width / canvas.height;

      var drawWidth, drawHeight, drawX, drawY;

      if (videoAspect > canvasAspect) {
        drawWidth = canvas.width;
        drawHeight = canvas.width / videoAspect;
        drawX = 0;
        drawY = (canvas.height - drawHeight) / 2;
      } else {
        drawWidth = canvas.height * videoAspect;
        drawHeight = canvas.height;
        drawX = (canvas.width - drawWidth) / 2;
        drawY = 0;
      }

      ctx.drawImage(video, drawX, drawY, drawWidth, drawHeight);
      addHotspots(0);
    } else {
      generateFallbackFrame(0);
    }

    initialRenderDone = true;
  }

  function loadVideo() {
    if (videoLoadingComplete) {
      return;
    }

    videoLoadAttempts++;

    if (videoLoadAttempts > maxVideoLoadAttempts) {
      videoLoadingComplete = true;
      isVideoLoaded = false;
      renderInitialFrame();
      return;
    }

    video.onloadedmetadata = null;
    video.onerror = null;
    video.onprogress = null;
    video.onloadstart = null;
    video.oncanplay = null;

    video.muted = true;
    video.preload = 'auto';
    video.playsInline = true;

    if (videoLoadAttempts === 1) {
      video.removeAttribute('crossOrigin');
    } else {
      video.crossOrigin = 'anonymous';
    }

    video.onloadedmetadata = function() {
      videoDuration = video.duration;
      video.currentTime = 0;
    };

    video.oncanplay = function() {
      if (!videoLoadingComplete) {
        videoLoadingComplete = true;
        isVideoLoaded = true;
        renderInitialFrame();
      }
    };

    video.onseeked = function() {
      if (!initialRenderDone && isVideoLoaded) {
        renderInitialFrame();
      }
    };

    var errorHandled = false;
    video.onerror = function(e) {
      if (errorHandled) return;
      errorHandled = true;

      if (videoLoadAttempts < maxVideoLoadAttempts) {
        setTimeout(function() {
          if (!videoLoadingComplete) {
            loadVideo();
          }
        }, 1000);
      } else {
        videoLoadingComplete = true;
        isVideoLoaded = false;
        renderInitialFrame();
      }
    };

    var loadTimeout = setTimeout(function() {
      if (!videoLoadingComplete && !errorHandled) {
        video.onerror(new Error('Timeout'));
      }
    }, 10000);

    var originalOnCanPlay = video.oncanplay;
    video.oncanplay = function() {
      clearTimeout(loadTimeout);
      if (originalOnCanPlay) originalOnCanPlay.call(this);
    };

    video.src = videoURL;
    video.load();
  }

  var lastDrawnFrame = -1;
  var videoFrameReady = false;
  var pendingVideoSeek = false;

  function seekToTime(targetTime) {
    return new Promise(function(resolve) {
      if (!isVideoLoaded) {
        resolve();
        return;
      }

      if (Math.abs(video.currentTime - targetTime) < 0.033) {
        resolve();
        return;
      }

      pendingVideoSeek = true;

      var onSeeked = function() {
        pendingVideoSeek = false;
        videoFrameReady = true;
        video.removeEventListener('seeked', onSeeked);
        resolve();
      };

      video.addEventListener('seeked', onSeeked);
      video.currentTime = targetTime;

      setTimeout(function() {
        if (pendingVideoSeek) {
          video.removeEventListener('seeked', onSeeked);
          pendingVideoSeek = false;
          resolve();
        }
      }, 1000);
    });
  }

  function renderVideoFrame(progress) {
    if (!isVideoLoaded) {
      generateFallbackFrame(progress);
      return Promise.resolve();
    }

    var targetTime = progress * videoDuration;
    var frameNumber = Math.round(progress * videoDuration * 30);

    if (frameNumber === lastDrawnFrame && videoFrameReady && !pendingVideoSeek) {
      return Promise.resolve();
    }

    return seekToTime(targetTime).then(function() {
      if (video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0) {
        ctx.fillStyle = 'rgb(253, 253, 253)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        var videoAspect = video.videoWidth / video.videoHeight;
        var canvasAspect = canvas.width / canvas.height;

        var drawWidth, drawHeight, drawX, drawY;

        if (videoAspect > canvasAspect) {
          drawWidth = canvas.width;
          drawHeight = canvas.width / videoAspect;
          drawX = 0;
          drawY = (canvas.height - drawHeight) / 2;
        } else {
          drawWidth = canvas.height * videoAspect;
          drawHeight = canvas.height;
          drawX = (canvas.width - drawWidth) / 2;
          drawY = 0;
        }

        ctx.drawImage(video, drawX, drawY, drawWidth, drawHeight);
        addHotspots(progress);

        lastDrawnFrame = frameNumber;
        currentTime = targetTime;
        videoFrameReady = true;
      } else {
        generateFallbackFrame(progress);
      }
    });
  }

  function generateFallbackFrame(progress) {
    ctx.fillStyle = 'rgb(240, 240, 240)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    var centerX = canvas.width / 2;
    var centerY = canvas.height / 2;
    var size = 100;

    ctx.save();
    ctx.translate(centerX, centerY);
    ctx.rotate(progress * Math.PI * 4);

    ctx.fillStyle = '#000';
    ctx.fillRect(-size/2, -size/2, size, size);

    ctx.restore();

    addHotspots(progress);
  }

  function addHotspots(progress) {
    if (!showHotspots) return;

    var tolerance = 0.02;

    var activeSegment = null;
    Object.values(segmentData).forEach(function(segment) {
      if (Math.abs(progress - segment.progress) < tolerance) {
        activeSegment = segment;
      }
    });

    if (activeSegment && activeSegment.hotspots) {
      activeSegment.hotspots.forEach(function(hotspot, index) {
        var x = hotspot.x * canvas.width;
        var y = hotspot.y * canvas.height;

        ctx.beginPath();
        ctx.arc(x, y, 38, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
        ctx.fill();

        ctx.beginPath();
        ctx.arc(x, y, 25, 0, Math.PI * 2);
        ctx.fillStyle = 'white';
        ctx.fill();

        ctx.beginPath();
        ctx.arc(x, y, 19, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
        ctx.fill();

        ctx.fillStyle = '#C83C1F';
        ctx.font = 'bold 23px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText((index + 1).toString(), x, y);
      });
    }
  }

  function render() {
    if (isRendering) return;

    isRendering = true;
    rafId = requestAnimationFrame(function() {
      var progress = animationData.progress;

      if (Math.abs(progress - lastProgress) < 0.001) {
        isRendering = false;
        return;
      }
      lastProgress = progress;

      if (isVideoLoaded) {
        renderVideoFrame(progress).then(function() {
          isRendering = false;
        });
      } else {
        generateFallbackFrame(progress);
        isRendering = false;
      }
    });
  }

  function updateActiveSegment(progress) {
    var segments = document.querySelectorAll('.saunder-animation-section .content-block');
    segments.forEach(function(segment) {
      segment.classList.remove('active');
    });

    var closestSegmentIndex = 0;
    var smallestDistance = Infinity;

    Object.entries(segmentData).forEach(function(entry, index) {
      var segment = entry[1];
      var distance = Math.abs(progress - segment.progress);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        closestSegmentIndex = index;
      }
    });

    if (segments[closestSegmentIndex]) {
      segments[closestSegmentIndex].classList.add('active');
    }
  }

  ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize"
  });

  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".saunder-animation-section .main-section",
      start: "top top",
      end: "+=2500vh",
      scrub: reducedMotion ? false : 1,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      snap: reducedMotion ? false : {
        snapTo: Object.values(segmentData).map(function(segment) { return segment.progress; }),
        duration: 0.8,
        delay: 0.3
      },
      onUpdate: function(self) {
        updateActiveSegment(self.progress);
      },
      onRefresh: function() {
        render();
      }
    }
  });

  tl.to(animationData, {
    progress: 1,
    duration: 1,
    ease: "none",
    onUpdate: render
  });

  if ('ontouchstart' in window) {
    document.addEventListener('touchstart', function() {}, { passive: true });
    document.addEventListener('touchmove', function() {}, { passive: true });
  }

  lastProgress = 0;

  ctx.fillStyle = 'rgb(253, 253, 253)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  document.querySelector('.saunder-animation-section .segment-0').classList.add('active');

  loadVideo();

  window.addEventListener('load', function() {
    if (!initialRenderDone && (isVideoLoaded || videoLoadingComplete)) {
      renderInitialFrame();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSaunderAnimation);
} else {
  initSaunderAnimation();
}
